import React, { ReactElement, useContext } from 'react'
import PersonContent from './PersonContent'
import { Routes, Route, useLocation } from 'react-router-dom'
import { PersonContext } from '../contexts/PersonContext'
import { PersonRetriever } from '../reducers/PersonReducer'
import { PersonThumbnailListWithField } from './PersonThumbnailList'
import ExplorePage from '../Explore/ExplorePage'

const PersonPage = (): ReactElement => {
    const { state } = useContext(PersonContext)
    const path = useLocation().pathname
    // The list paths (relative to the /people/* mount) carry params, so need real routes; the fallback
    // shows the selected person under /person, else the explore view.
    const fallback = state.selectedPerson && path.startsWith('/person')
        ? <PersonRetriever>
            <PersonContent personId={ +state.selectedPerson } />
        </PersonRetriever>
        : <ExplorePage />

    return (
        <div className="page person-page">
            <Routes>
                <Route path="with/:field/:comparison/:value" element={ <PersonThumbnailListWithField /> } />
                <Route path="by/:field/:comparison/:value" element={ <PersonThumbnailListWithField /> } />
                <Route path="with/:field/:value" element={ <PersonThumbnailListWithField /> } />
                <Route path="by/:field/:value" element={ <PersonThumbnailListWithField /> } />
                <Route path="by/:field" element={ <PersonThumbnailListWithField /> } />
                <Route path="*" element={ fallback } />
            </Routes>
        </div>
    )
}

export default PersonPage
